<template lang="pug">
tr.lobby-game-row
  td.pl-4
    span {{ game.text }}
  td.pl-4
    BaseTextField(rules="host" v-model="img" @input="sendValue", :label="translations.label.gamesimg")
  td.pl-4
    v-switch.mt-0(v-model="extra.isNew" color="primary" hide-details @change="sendValue")
  td.pl-4
    v-switch.mt-0(v-model="extra.hot" color="primary" hide-details @change="sendValue")
  td.pl-4
    v-switch.mt-0(v-model="extra.isfeaturedNew" color="primary" hide-details @change="sendValue")
</template>

<script>

  export default {
    name: "LobbyGameRow",
    props: {
      game: {
        type: Object,
        default: function(){
          return {
            text: '',
            value: '',
            img: '',
            extra: {
              isNew: false,
              featured: false,
              hot: false,
            }
          }
        }
      },
      translations: {
        type: Object,
        default: function(){
          return {}
        }
      },
    },
    data:() =>({
      img: '',
      extra: {
        isNew: false,
        featured: false,
        hot: false,
      },
    }),
    created(){
      this.img = this.game.img != undefined ? this.game.img : '';
    },
    methods:{
      sendValue(){
        let game = {
          value: this.game.value,
          text: this.game.text,
          img: this.img,
          extra: {
            isNew: this.extra.isNew,
            featured: this.extra.featured,
            hot: this.extra.hot,
          },
        };
        this.$emit('input', game);
      },
    },
  }
</script>

<style lang="sass">
.lobby-game-row
  box-shadow: 0 -1px 0 0 #999
  &:hover
    background: #eee
</style>